var _style, _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgKoiReaderEmblem = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "KoiReaderEmblem_svg__Layer_1",
  x: 0,
  y: 0,
  viewBox: "0 0 30 44"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".KoiReaderEmblem_svg__st1{fill:#3499cc}.KoiReaderEmblem_svg__st2{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
  d: "m4.5 42.9 8.7-11-5.8-13.2 3.9-8.1-6.8-9.5z",
  style: {
    fill: "#6e6e6e"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m5.4 26.2 14.5 16c.3.4.8.6 1.3.6h5.4c1.5 0 2.3-1.8 1.3-2.9L12.2 22.6c-.6-.7-.6-1.7 0-2.4L27.6 4.6c1.1-1.1.3-3-1.3-3H21c-.5 0-.9.2-1.2.5L7.5 14.3l-5.4 5.8c-.6.7-.6 1.7 0 2.4z",
  className: "KoiReaderEmblem_svg__st1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m8.5 20.9 4.8-4.8-1.9-1.8-.4.3 1.4 1.5-4.1 4.2z",
  className: "KoiReaderEmblem_svg__st2"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 11.3,
  cy: 14.5,
  r: 0.6,
  className: "KoiReaderEmblem_svg__st2"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.3,
  cy: 16.5,
  r: 0.6,
  className: "KoiReaderEmblem_svg__st2"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.6,
  cy: 29.7,
  r: 0.7,
  className: "KoiReaderEmblem_svg__st2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m6.4 18.1.3.6 1.7-1.9-.4-.4zM6.9 24l-.6.2 5 5.6.5-.4z",
  className: "KoiReaderEmblem_svg__st2"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m9.5 22.2-2.6 2.6c-.4.4-1.1.4-1.5 0l-2.6-2.6c-.4-.4-.4-1.1 0-1.5l2.6-2.6c.4-.4 1.1-.4 1.5 0l2.6 2.6c.4.4.4 1.1 0 1.5",
  className: "KoiReaderEmblem_svg__st2"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m9 21.9-2.3 2.3c-.3.3-.7.3-1 0l-2.4-2.4c-.3-.3-.3-.7 0-1l2.3-2.3c.3-.3.7-.3 1 0L9 20.9c.2.3.2.7 0 1",
  className: "KoiReaderEmblem_svg__st1"
})));
export default SvgKoiReaderEmblem;